module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_6_1.06a0c297.jpeg";